import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './product.reducer';

export const ProductDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const productEntity = useAppSelector(state => state.product.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="productDetailsHeading">
          <Translate contentKey="crawlerBackendApp.product.detail.title">Product</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{productEntity.id}</dd>
          <dt>
            <span id="productStatus">
              <Translate contentKey="crawlerBackendApp.product.productStatus">Product Status</Translate>
            </span>
          </dt>
          <dd>{productEntity.productStatus}</dd>
          <dt>
            <span id="feedType">
              <Translate contentKey="crawlerBackendApp.product.feedType">Feed Type</Translate>
            </span>
          </dt>
          <dd>{productEntity.feedType}</dd>
          <dt>
            <span id="feedInType">
              <Translate contentKey="crawlerBackendApp.product.feedInType">Feed In Type</Translate>
            </span>
          </dt>
          <dd>{productEntity.feedInType}</dd>
          <dt>
            <span id="productType">
              <Translate contentKey="crawlerBackendApp.product.productType">Product Type</Translate>
            </span>
          </dt>
          <dd>{productEntity.productType}</dd>
          <dt>
            <span id="initialEstimatedYearlyQuantity">
              <Translate contentKey="crawlerBackendApp.product.initialEstimatedYearlyQuantity">
                Initial Estimated Yearly Quantity
              </Translate>
            </span>
          </dt>
          <dd>{productEntity.initialEstimatedYearlyQuantity}</dd>
          <dt>
            <span id="retrievedYearlyQuantityReading">
              <Translate contentKey="crawlerBackendApp.product.retrievedYearlyQuantityReading">
                Retrieved Yearly Quantity Reading
              </Translate>
            </span>
          </dt>
          <dd>{productEntity.retrievedYearlyQuantityReading}</dd>
          <dt>
            <span id="initialFixedAnnualPrice">
              <Translate contentKey="crawlerBackendApp.product.initialFixedAnnualPrice">
                Initial Fixed Annual Price
              </Translate>
            </span>
          </dt>
          <dd>{productEntity.initialFixedAnnualPrice}</dd>
          <dt>
            <span id="activeDate">
              <Translate contentKey="crawlerBackendApp.product.activeDate">Active Date</Translate>
            </span>
          </dt>
          <dd>
            {productEntity.activeDate ? (
              <TextFormat value={productEntity.activeDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="inactiveDate">
              <Translate contentKey="crawlerBackendApp.product.inactiveDate">Inactive Date</Translate>
            </span>
          </dt>
          <dd>
            {productEntity.inactiveDate ? (
              <TextFormat value={productEntity.inactiveDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="usage">
              <Translate contentKey="crawlerBackendApp.product.usage">Usage</Translate>
            </span>
          </dt>
          <dd>{productEntity.usage}</dd>
          <dt>
            <span id="desireStartDate">
              <Translate contentKey="crawlerBackendApp.product.desireStartDate">Desire Start Date</Translate>
            </span>
          </dt>
          <dd>
            {productEntity.desireStartDate ? (
              <TextFormat value={productEntity.desireStartDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="desireEndDate">
              <Translate contentKey="crawlerBackendApp.product.desireEndDate">Desire End Date</Translate>
            </span>
          </dt>
          <dd>
            {productEntity.desireEndDate ? (
              <TextFormat value={productEntity.desireEndDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.product.productOrder">Product Order</Translate>
          </dt>
          <dd>{productEntity.productOrder ? productEntity.productOrder.id : ''}</dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.product.productOffering">Product Offering</Translate>
          </dt>
          <dd>{productEntity.productOffering ? productEntity.productOffering.id : ''}</dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.product.ean">Ean</Translate>
          </dt>
          <dd>{productEntity.ean ? productEntity.ean.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/product" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/product/${productEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ProductDetail;
